import DetailsHeader from 'views/declarations/common/ics2-message-details/DetailsHeader';
import MessageDetails from 'views/declarations/common/ics2-message-details/MessageDetails';
import ConsignmentStatusList, { ConsignmentStatus } from '../components/ConsignmentStatusList';

type Props = {
    notification?: any;
    onBack: () => void;
};

// TODO: The mock will be replaced in a follow-up
const MOCK_CONSIGNMENTS: ConsignmentStatus[] = [
    {
        name: 'Master Consignment',
        id: 'HEM189389204003',
        statusLabel: 'Assessment Complete',
        status: 'success',
    },
    {
        name: 'House Consignment',
        id: 'LWN93937',
        statusLabel: 'Under Risk Analysis',
        status: 'warning',
    },
    {
        name: 'House Consignment',
        id: 'BNT93022',
        statusLabel: 'In Progress',
        status: 'default',
    },
];

const IE3R08Details = ({ onBack }: Props) => (
    <>
        <DetailsHeader onBack={onBack} />

        <MessageDetails
            // TODO: The mock will be replaced in a follow-up
            messageMetadata={{
                Code: 'IE3R08',
                Message: 'ENS Consultation Results',
                'Referral Request': 'Q05-00041872',
                'Affected Consignments': '-',
                'Issued By': 'Customs Office GB00000001',
                'Issued At': '01/04/2026, 14:23',
            }}
        >
            <ConsignmentStatusList consignments={MOCK_CONSIGNMENTS} />
        </MessageDetails>
    </>
);

export default IE3R08Details;
